module.exports = __webpack_public_path__ + "img/Screenshot-Presentation.79c96725.png";